exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product.collection-product[data-v-db395392]{padding-right:0;width:auto;margin:20px !important}@media (max-width: 767px){.product.collection-product[data-v-db395392]{margin:0 !important;max-width:190px}}\n", ""]);

// exports
